import styled from 'styled-components'

import { palette } from '_styles/variables'

export const Styles = styled.div`
  table {
    display: inline-block;
    margin-top: 0.4375rem;
    border-spacing: 0;
    border-bottom: 0.0625rem solid ${palette.neutral['grey-bbbdbf']};

    td {
      margin: 0;
      padding-top: 0.125rem;
      padding-bottom: 0.125rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      border-left: 0.0625rem solid ${palette.neutral['grey-bbbdbf']};
      border-top: 0.0625rem solid ${palette.neutral['grey-bbbdbf']};
      &:last-child {
        padding-right: 1.25rem;
        border-right: 0.0625rem solid ${palette.neutral['grey-bbbdbf']};
      }
    }
  }
`
